import { cn } from '@bem-react/classname';

export const cnTooltip = cn('Tooltip');
